import { EcrAlreadyExistsProps, ValidationResult } from './types';

export const ecrAlreadyExists = async ({
  baseUrl,
  token,
  ecrName,
}: EcrAlreadyExistsProps): Promise<ValidationResult> => {
  const projectUrl = new URL(`${baseUrl}/infinity-api/ecr`);
  projectUrl.search = new URLSearchParams({
    name: ecrName,
  }).toString();

  const response = await fetch(projectUrl.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (response.status !== 404) {
      throw new Error(`Infinity ecr api error ${response.status}`);
    }
  }
  const { message: ecrArn } = (await response.json()) as { message: string };
  const ecrExists = ecrArn?.includes('arn');
  return {
    error: 'ECR repository to store container images already exists.',
    result: ecrExists ? 'failed' : 'success',
    details: ecrExists ? ecrArn : '',
    fix: `Rename the template, it'll change the ECR name.`,
  };
};
